import {hasValue} from '@shared/utils/helpers';

export class Queue<T> {
  private storage: T[] = [];

  constructor(private capacity: number = Infinity) {
  }

  /**
   * Splits the queue from the index to the left e.g.
   * if called with index "2" then "[0, 1, 2 | , 3, 4, 5]" -> "[3, 4, 5]"
   * @param index
   */
  splitQueue(index: number) {
    if (/*this.storage.length === 1 && */index === 0) {
      this.storage.shift();
      // this.storage = [];
    } else {
      this.storage.splice(0, index);
    }
  }

  enqueue(item: T): void {
    if (this.size === this.capacity) {
      throw Error('Queue has reached max capacity, you cannot add more items');
    }
    this.storage.push(item);
  }

  async enqueueMany(items: T[]): Promise<void> {
    this.storage.push.apply(this.storage, items);
  }

  dequeue(): T | undefined {
    return this.storage.shift();
  }

  get peekNextInQueue(): T | null {
    return hasValue(this.storage) ? this.storage[0] : null;
  }

  get size(): number {
    return this.storage.length;
  }

  get isEmpty(): boolean {
    return this.size <= 0;
  }

  find(predicate: (value: T, index: number, obj: T[]) => unknown): T {
    return this.storage.find(predicate);
  }

  findIndex(predicate: (value: T, index: number, obj: T[]) => unknown): number {
    return this.storage.findIndex(predicate);
  }

  get(index: number): T {
    return this.storage[index];
  }

  remove(index: number): T {
    const returning = this.get(index);

    this.storage.splice(index, 1);

    return returning;
  }

/**
 * peek Next items from the queue
 * @param numberOfItemsToPeek
 * @returns
 */
  peekNextItems(numberOfItemsToPeek: number): Array<T> {

    return this.storage.slice(0, numberOfItemsToPeek);
  }

}
